export const showCategories = (state) => state.categories
